module.exports = {
	"library.footer.terms_of_use": "Condiciones de uso",
	"library.footer.terms_and_conditions": "Términos y condiciones",
	"library.footer.privacy_policy": "Política de privacidad",
	"library.footer.get_to_know_us": "Conócenos",
	"library.footer.about": "Sobre nosotros",
	"library.footer.jobs": "Empleos",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Obtener ayuda",
	"library.footer.find_events": "Encontrar eventos",
	"library.footer.top_events": "Eventos principales",
	"library.footer.host_events": "Organizar eventos",
	"library.footer.become_a_host": "Conviértete en organizador",
	"library.footer.tour": "Visita",
	"library.footer.embeddable_widgets": "Widgets incrustables",
	"library.footer.customers": "Clientes",
	"library.footer.pricing": "Precios",
	"library.footer.get_the_onsite_app": "Descarga la aplicación del evento",
	"library.footer.developers": "Desarrolladores",
	"library.footer.contact_us": "Contacta con nosotros"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/es.json
// module id = 1596
// module chunks = 0 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16